function runPo2go() {
  var store_config = {
    "punchout_only": 0,
    "allow_zero_value_cart": false,
    "graphql_token":"a703122e972bc9bafc71daa609250c90",
    "cart_transfer_metafields": [
      "custom.service_type",
      "custom.unit_of_measurement",
      "custom.is_bundle_product"
        ],
    "watch_for_missing_transfer_button": true,
    "transfer_button_container_selector": ".cart__ctas",
    "transfer_label": "Transfer Cart",
    "custom_style": "body.punchout a.btn--secondary.button.cart__checkout { display: none;} body.punchout .cart__dynamic-checkout-buttons.additional-checkout-buttons {display: none;} body.punchout cart-notification { display: none !important; }",
    "checkout_selector": "button[name=\"checkout\"]",
    "transfer_selector": "button[name=\"transfer_items\"]",
    "transfer_btn_html": "<button type=\"submit\" name=\"transfer_items\" class=\"btn font-weight-600 w-full text-uppercase large_body\" onClick=\"POSession.extension.transferCart(); return false;\">Transfer Cart</button>",
    "return_selector": "header",
    "return_btn_html": "<button type=\"submit\" name=\"close_punchout\" class=\"btn return_btn\" onClick=\"POSession.cancel();\">Close PunchOut<\/button>"
  };

  POExt = new Po2go_Shopify(store_config);
  POSession = new Po2go({
    'account': '',
    'punchout_only': store_config.punchout_only,
    'extension': POExt
  });
  POSession.init();
  POSession.extension.setupPage();
  POSession.extension.returnToProcButton();

  // Only set up the observer if this is an active punchout session
if (!document.body.classList.contains('punchout')) return;

  const observer = new MutationObserver(() => {
    const checkoutBtn = document.querySelector('cart-drawer button[name="checkout"]');
    const transferBtn = document.querySelector('cart-drawer button[name="transfer_items"]');
    const ctasContainer = document.querySelector('.cart__ctas');

    if (checkoutBtn && ctasContainer && !transferBtn) {
      checkoutBtn.style.display = 'none';
      ctasContainer.insertAdjacentHTML(
        'afterbegin',
        store_config.transfer_btn_html
      );
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
}
